module.exports = __webpack_public_path__ + "static/media/bistrotext.3e5bc30a.png";